var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaunchForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5528_245622)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5431 1.05388C19.8323 1.3431 19.8263 1.81793 19.5298 2.11446L9.19137 12.4529C8.89484 12.7494 8.42 12.7554 8.13079 12.4662C7.84158 12.1769 7.84751 11.7021 8.14404 11.4056L18.4825 1.06713C18.779 0.770604 19.2539 0.764672 19.5431 1.05388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5498 1.05373C19.751 1.2549 19.8162 1.55644 19.7176 1.82954L13.4193 19.2805C13.032 20.3536 11.5431 20.4329 11.0963 19.4042L8.09919 12.5044L1.19931 9.50729C0.170601 9.06046 0.249896 7.57152 1.32304 7.1842L18.774 0.8859C19.0471 0.787331 19.3486 0.852562 19.5498 1.05373ZM2.39858 8.37796L8.81285 11.1641C9.09404 11.2862 9.31732 11.5095 9.43946 11.7907L12.2256 18.205L17.7752 2.8283L2.39858 8.37796Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5528_245622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchForm);
export default __webpack_public_path__ + "static/media/launchForm.aa63e038606a9d3314700fb57294d319.svg";
export { ForwardRef as ReactComponent };